import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

// const ProductCard = ({ product, handleAddToCart }) => {
const ProductCard = (props) => {
  return (
    <Card className="card">
      <CardMedia component="img" height="140" image={props.image} alt="Video" />
      <CardContent>
        <Typography color="text.primary" gutterBottom>
          {props.name}
        </Typography>
        <Typography gutterBottom variant="h6">
          {props.category}
        </Typography>
        <Typography color="text.secondary">{props.cost}</Typography>
        <Rating name="read-only" value={props.rating} readOnly />
      </CardContent>

      <Button
        onClick={props.handleAddToCart}
        className="card-button"
        variant="contained"
        startIcon={<AddShoppingCartOutlined />}
      >
        ADD TO CART
      </Button>
    </Card>
  );
};

export default ProductCard;
